import * as React from 'react';

import logger from 'js/app/loggerSingleton';

import ValuePropositionComponent, {
  type AdditionalContent,
} from 'bundles/browse-common/components/ValuePropositionComponent';
import { useValueProposition } from 'bundles/browse-common/contexts/ValuePropositionContext';
import { usePageConfigComponentMetadata } from 'bundles/page-config-common/contexts/PageConfigComponentMetadataContext';

const ValuePropositionRenderer = () => {
  const pageConfigMetadataContext = usePageConfigComponentMetadata();
  const valuePropositionContext = useValueProposition();

  if (!pageConfigMetadataContext) {
    logger.warn('ValuePropositionRenderer expected PageConfigComponentMetadataProvider');
    return null;
  }

  if (!valuePropositionContext) {
    logger.warn('ValuePropositionRenderer expected ValuePropositionContext');
    return null;
  }

  const { index } = pageConfigMetadataContext;
  const { title, description, valuePropositionItems } = valuePropositionContext;

  const additionalContent: AdditionalContent[] =
    valuePropositionItems?.map((item) => ({
      text: item.text || '',
    })) || [];

  return (
    <ValuePropositionComponent
      showPageTitleHeadingSize={index === 0}
      title={title}
      description={description}
      additionalContent={additionalContent}
    />
  );
};

export default ValuePropositionRenderer;
